import Vue from 'vue'
import Router from 'vue-router'
import store from '..//store'
import devicemanage from '@/components/devicemanage/devicemanage'
import addDevice from '@/components/addDevice/addDevice'
import guide from '@/components/guide/guide'
import info from '@/components/info/info'
import baidu from '@/components/baidu/baidu'
import msgLog from '@/components/msgLog/msgLog'
import send from '@/components/send/send'
import userList from '@/components/userManage/userList'
import addUser from '@/components/userManage/addUser'
import fen from '@/components/userManage/fen'
import dao from '@/components/userManage/dao'
import quanxian from '@/components/userManage/quanxian'
import login from '@/components/login'
//import setsong from '@/components/setsong/setsong'
import register from '@/components/register'
import baojing from '@/components/devicemanage/baojing'
import shuju from '@/components/devicemanage/shuju'
import port from '@/components/devicemanage/port'
import dingshi from '@/components/devicemanage/dingshi'
import port1 from '@/components/devicemanage/port1'
import ditu from '@/components/baidu/ditu'
import devicemanage1 from '@/components/devicemanage/devicemanage1'
import devicemanage2 from '@/components/devicemanage/devicemanage2'


Vue.use(Router)
Vue.use(store)

const router = new Router({
  routes: [
    {
      path: '/ditu/:eqId',
      name: 'ditu',
      component: ditu
    },
    {
      path: '/baojing/:eqId',
      name: 'baojing',
      component: baojing
    },
    {
      path: '/dingshi/:eqId/:eqType',
      name: 'dingshi',
      component: dingshi
    },
   {
      path: '/port1/:eqId',
      name: 'port1',
      component: port1
    },
    {
      path: '/shuju/:eqId',
      name: 'shuju',
      component: shuju
    },
    {
      path: '/port/:eqId/:eqType',
      name: 'port',
      component: port
    },
   
    {
      path: '/userManage',
      name: 'userList',
      component: userList
    },
    {
      path: '/quanxian/:uId',
      name: 'quanxian',
      component: quanxian
    },
    {
      path: '/fen/:uId',
      name: 'fen',
      component: fen
    },
    {
      path: '/dao/:uId',
      name: 'dao',
      component: dao
    },
    {
      path: '/send',
      name: 'send',
      component: send
    },
//  {
//    path: '/setsong',
//    name: 'setsong',
//    component: setsong
//  },
    {
      path: '/msgLog',
      name: 'msgLog',
      component: msgLog
    },
    {
      path: '/devicemanage',
      name: 'devicemanage',
      component: devicemanage
    },
    {
      path: '/addDevice',
      name: 'addDevice',
      component: addDevice
    },
    {
      path: '/addUser',
      name: 'addUser',
      component: addUser
    },
    {
      path: '/info',
      name: 'info',
      component: info
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/baidu',
      name: 'baidu',
      component: baidu
    },
    {
      path: '/register',
        name: 'register',
      component: register
    },
    {
      path: '/',
      name: 'index',
      redirect: '/login'
    }
  ],
  linkActiveClass: 'active'
})

const history = window.sessionStorage;

router.beforeEach((to, from, next) => {
  if(to.fullPath == "/login"){
    next()
  }else{
  //  console.log(history.getItem("user"))
   //如果UID为空我就要退出到登陆页面
   if (history.getItem("user") == ''||history.getItem("user") == null) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  }

})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js